<template>
    <div class="score">
        <span class="label">Start score:</span>
        <b-form-input
            :value="startscore"
            @input="changeStartScore"></b-form-input>
    </div>
</template>

<script>
export default {
    name: 'design-2021-quest-user-start-score-component',
    props: ['startscoreIn', 'questId', 'userId', 'fullName'],
    data() {
        return {
            startscore: this.startscoreIn.length ? this.startscoreIn[0].score : 0,
        };
    },
    methods: {
        changeStartScore(value) {
            var data = {};
            data.startscore = value;

            this.axios.post(this.routes.questSaveStartScore(this.questId, this.userId), data).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.score {
    display: flex;
    flex: 1 0 100%;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .label {
        margin-bottom: 0;
        margin-right: map-get($grid-gutter-spacing, 'ten');
    }

    input {
        width: 100px;
        margin-bottom: 0;
    }
}
</style>
